import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

/*
const isRetina = () => {
  if (typeof window !== 'undefined') {
    return window.devicePixelRatio > 1;
  }
  return false;
};
*/

const Logo = () => (
  <Link to="/" title="Home">
    <StaticImage
      className="w-auto h-8 max-w-[180px]"
      src="large.png"
      alt="Digital Inspiration"
    />
  </Link>
);

export default Logo;
